// Render the page's existing `.radios` / `.radio-opt` / `.selected` markup
// as a React-controlled group. One place that knows how to toggle the
// `selected` class, instead of replicating it at each call site.

export interface RadioOption<V extends string> {
  value: V;
  label: React.ReactNode;
}

interface Props<V extends string> {
  name: string;
  group?: string; // data-group, kept for parity with the HTML draft
  value: V | null;
  onChange: (next: V) => void;
  options: ReadonlyArray<RadioOption<V>>;
}

export function RadioGroup<V extends string>({
  name,
  group,
  value,
  onChange,
  options,
}: Props<V>): JSX.Element {
  return (
    <div className="radios" data-group={group}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <label
            key={opt.value}
            className={"radio-opt" + (selected ? " selected" : "")}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={selected}
              onChange={() => onChange(opt.value)}
            />
            <span>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}
